module.exports = __webpack_public_path__ + "static/media/Rectangle.4f420c4d.png";